(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["fido"] = factory();
	else
		root["fido"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/Fido.js":
/*!*********************!*\
  !*** ./src/Fido.js ***!
  \*********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Fido; });
/* harmony import */ var _PrefetchHintDetector__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PrefetchHintDetector */ "./src/PrefetchHintDetector.js");
/* harmony import */ var _swReg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./swReg */ "./src/swReg.js");
/* harmony import */ var _strategies_PrefetchFactory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./strategies/PrefetchFactory */ "./src/strategies/PrefetchFactory.js");
/* harmony import */ var _PrefetchRegistry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PrefetchRegistry */ "./src/PrefetchRegistry.js");
/* harmony import */ var _PrefetchScheduler__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PrefetchScheduler */ "./src/PrefetchScheduler.js");
/* harmony import */ var _preload_Preloader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./preload/Preloader */ "./src/preload/Preloader.js");
/* harmony import */ var _delay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./delay */ "./src/delay.js");
/* harmony import */ var _priority__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./priority */ "./src/priority.js");








const DEFAULT_INITIAL_DELAY_MS = 1000;


 class Fido {
    constructor(configuration) {
        configuration = configuration || {};

        // This function looks at an element and can return a custom hint if found.
        // If no custom hint is found, we'll use the default hint detection behavior.
        this.customHintFunc = configuration.customHintFunc || (() => undefined);

        // This is the query that finds the initial set of elements with hints.
        this.customQuerySelector = configuration.customQuerySelector || "[data-fidoprefetchhint]";

        this.initialDelayMs = configuration.initialDelayMs || DEFAULT_INITIAL_DELAY_MS;

        this.prefetchRegistry = new _PrefetchRegistry__WEBPACK_IMPORTED_MODULE_3__["default"]();
        this.prefetchScheduler = new _PrefetchScheduler__WEBPACK_IMPORTED_MODULE_4__["default"]();
        this.preloader = new _preload_Preloader__WEBPACK_IMPORTED_MODULE_5__["default"]();
    }

    // Whenever the "hint detector" finds a hint, it calls this.
    onHintFound(hint) {
        // filter out hint.hrefs which match the current page url
        const currentHref = window.location.href.split('?')[0]
        const hrefs = hint.hrefs.filter(href => href !== currentHref)

        if (hrefs.length === 0) {
            return
        }

        const filteredHint = {
            ...hint,
            hrefs
        }

        const prefetch = _strategies_PrefetchFactory__WEBPACK_IMPORTED_MODULE_2__["default"].create(filteredHint, this.prefetchScheduler);
        this.prefetchRegistry.register(prefetch);
    }

    // When the hint detector sees that an element is deleted, it calls this.
    // The element might not have actually had a prefetch attached to it, but that's okay.
    onDeleteElement(element) {
        this.prefetchRegistry.cancel(element);
    }

    prefetchOnHover(element, priority, ...hrefs) {
        const hint = {
            element: element,
            type: "HOVER",
            hrefs: hrefs.length > 0 ? hrefs : [ element.href ],
            priority
        };
    
        this.onHintFound(hint);
    }
    
    removePrefetchOnHover(element) {
        fido.onDeleteElement(element);
    }
    
    prefetch(url, priority) {
        const hint = {
            element: null,
            type: "EAGER",
            hrefs: [ url ],
            priority
        };
    
        this.onHintFound(hint);
    }
    
    // Start fido searching for hintsm,
    start() {
        const prefetchHintDetector = new _PrefetchHintDetector__WEBPACK_IMPORTED_MODULE_0__["default"](
            this.customHintFunc, 
            this.customQuerySelector, 
            this.onHintFound.bind(this),
            this.onDeleteElement.bind(this));

        invokeOnWindowLoad(async () => {
            try {
                // Register the service worker.
                Object(_swReg__WEBPACK_IMPORTED_MODULE_1__["registerServiceWorker"])();

                // Register the event handler that prefetches
                // hints from the service worker.
                this.registerServiceWorkerListener();

                // This initial delay gives the browser a little more time to 
                // do its thing before we start taking up some of its bandwidth
                // for prefetching.
                //
                // TODO - there's probably a better way to determine that the network
                // is idle.
                if (this.initialDelayMs) {
                    await Object(_delay__WEBPACK_IMPORTED_MODULE_6__["default"])(this.initialDelayMs);
                }

                prefetchHintDetector.start();
            } catch (err) {
                console.error("Fido initialization failed", err);
            }
        });
    }

    // Listens for incoming prefetch requests from the service worker.
    // These hints are for shared and exclusive hints (shared meaning that it's a high priority resource that's shared by
    // multiple pages. Exclusive means that the resource is specific to a particular page.)
    // interface PrefetchHint {
    //   type: "PREFETCH_HINTS",
    //   domain?: string     // The domain to prepend to relative prefetch hints (absolute URLs override this behavior.)
    //   source: string      // The source URL of the prefetch hint; needed for exclusive hints.
    //   shared: string[]    // A set of hints for shared resources
    //   exclusive: string[] // A set of hints for exclusive, page-specific resources
    // }
    registerServiceWorkerListener() {
        const handlePrefetchHint = (event) => {
            const domain = event.data.domain
                ? event.data.domain
                : window.location.hostname + (parseInt(window.location.port) ? ":" + window.location.port : "");

            const sharedHints = (event.data.shared || [])
                .map(hint => applyDomainToHint(domain, hint));
            const exclusiveHints = (event.data.exclusive || [])
                .map(hint => applyDomainToHint(domain, hint));

            for (const sharedHint of sharedHints) {
                this.prefetch(sharedHint, true);
            }

            // For exclusive hints, we download them when we hover on the source
            // of the hint.
            if (exclusiveHints.length > 0) {
                const sourceUrl = event.data.source;
                const relativePath = sourceUrl.substring(new URL(sourceUrl).origin.length);

                if (relativePath.length > 1) {

                    // Find all the a elements whose targets end with the source path
                    // By searching on the path, we can get absolute and relative URLs.
                    const linksToHint = document.querySelectorAll(`a[href$="${relativePath}"`);
                    for (const linkToHint of linksToHint) {
                        this.prefetchOnHover(linkToHint, _priority__WEBPACK_IMPORTED_MODULE_7__["HIGH_PRIORITY"], ...exclusiveHints);
                    }
                }
            }
        };

        const handlePrefetchWorkerHint = (event) => {
            const workerHint = event.data.worker;

            try {
                const workerUrl = new URL(workerHint, window.location.origin);

                // Ensure same-origin policy applies
                if (workerUrl.origin !== window.location.origin) {
                    return;
                }

                // Ensure web-workers are supported by the browser
                if (typeof(Worker) === 'undefined') {
                    console.log('[Fido.js] Web Workers are not supported by this browser. Ignoring prefetch worker...');
                    return;
                }

                this.preloader.register(workerHint, workerUrl);
            } catch (err) {
                console.log(`[Fido.js] Unable to register preloading Web Worker: '${workerHint}'`, err);
            }
        };

        if (navigator && navigator.serviceWorker) {
            navigator.serviceWorker.addEventListener('message', event => {
                switch (event.data.type) {
                    case 'PREFETCH_HINTS':
                        handlePrefetchHint(event);
                        break;
                    case 'PREFETCH_WORKER_HINT':
                        handlePrefetchWorkerHint(event);
                        break;
                }
            });
        }
    }
}

function invokeOnWindowLoad(callback) {
    // Just in case the window is already loaded, we still want to invoke this callback.
    if (document.readyState === "complete") {
      callback();
    } else {
      window.addEventListener("load", callback);
    }
}

function applyDomainToHint(domain, url) {
    const isRootRelative = domain.startsWith('/');
  
    // The domain parameter will be one of:
    // a) a hostname (with no scheme)
    // b) a root-relative path ('/' prefix)
  
    return url.startsWith('http')
      ? url
      : isRootRelative
        ? domain + url
        : '//' + domain + url;
}

/***/ }),

/***/ "./src/PrefetchHintDetector.js":
/*!*************************************!*\
  !*** ./src/PrefetchHintDetector.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PrefetchHintDetector; });
// These are the set of attributes that we'll listen for changes on.
const FIDO_HINT_ATTRIBUTES = [
    "href",
    "data-fidoprefetchhref",
    "data-fidoprefetchhint",
    "data-fidoprefetchdelay",
    "data-fidoprefetchpriority"
]

class PrefetchHintDetector {
    /**
     * @constructor
     * @param customHintFunc 
     * An optional function which takes an element and returns a hint, or undefined
     * if the element doesn't have a hint.
     * @param customQuerySelector
     * An optional query string that will identify the initial elements
     * that have hints on them.
     * @param onHintFound
     * This callback will be called with a hint whenever one is found
     * @param onDeleteElement
     * This callback will be called whenever an element is deleted from the DOM. The element may or may not have prefetches
     * attached to it.
     */
    constructor(customHintFunc, customQuerySelector, onHintFound, onDeleteElement) {
        this.customHintFunc = customHintFunc || (() => undefined);
        this.querySelector = "[data-fidoprefetchhint]" + ((customQuerySelector) ? `,${customQuerySelector}` : '');
        this.onHintFound = onHintFound || (() => {});
        this.onDeleteElement = onDeleteElement || (() => {});
    }

    start() {
        // When we first start up, we want to look at the DOM for elements with hints.
        // After this initial pass, all hints will be discovered through the mutation observer.
        const initialElements = document.querySelectorAll(this.querySelector);
        
        for (const element of initialElements) {
            const hint = this.getHintFromElement(element);
            if (hint) {
                this.onHintFound(hint);
            }
        }

        // And set up a mutation observer to look for changes.
        if ("MutationObserver" in window) {
            const mutationObserver = new MutationObserver(mutations => {
                for (const mutation of mutations) {
                  if (mutation.type === 'childList') {
                    for (const addedNode of mutation.addedNodes) {
                      this.findHints(addedNode);
                    }
                    for (const removedNode of mutation.removedNodes) {
                      this.removeHint(removedNode);
                    }
                  } else if (mutation.type === 'attributes') {
                    this.findHints(mutation.target);
                  }
                }
              });
              mutationObserver.observe(document.body, { childList: true, subtree: true, attribute: true, attributeFilter: FIDO_HINT_ATTRIBUTES });
        }
    }

    getHintFromElement(element) {
        const hint = this.customHintFunc(element) || this.getDefaultHintFromElement(element);
        if (hint) {
            if (!hint.hrefs || hint.hrefs.length === 0) {
                hint.hrefs = [ element.href ];
            }
            return hint;
        }
    }

    getDefaultHintFromElement(element) {
        if (element && element.dataset && element.dataset.fidoprefetchhint) {
            const hrefs = this.getPrefetchHrefs(element);
            if (hrefs.length > 0) {
                return {
                    element,
                    hrefs,
                    type: element.dataset.fidoprefetchhint,
                    delay: element.dataset.fidoprefetchdelay,
                    priority: element.dataset.fidoprefetchpriority,
                };
            }
        }
    }

    getPrefetchHrefs(element) {
        if (element.dataset) {
            const href = element.dataset.fidoprefetchhref;
            if (href && href.length > 0) {
            return [ href ];
            }
        }
        
        return element.href ? [ element.href ] : [];
    }

    // Get any hints on this element or its ancestors
    findHints(element) {
        const hint = this.getHintFromElement(element);
        if (hint) {
            this.onHintFound(hint);
        }

        if (element.children) {
            for (const child of element.children) {
                this.findHints(child);
            }
        }
    }

    removeHint(element) {
        const hint = this.getHintFromElement(element);

        if (hint) {
            this.onDeleteElement(element);
        }
    }
}

/***/ }),

/***/ "./src/PrefetchRegistry.js":
/*!*********************************!*\
  !*** ./src/PrefetchRegistry.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PrefetchRegistry; });
// This class registers prefetches, and cancels them if they haven't already been prefetched.
// Registering a prefetch means that it is able to be "triggered," for example, when the user
// hovers over an element. Registering a prefetch doesn't mean it'll actually get queued up and
// downloaded.
class PrefetchRegistry {
    constructor() {
        this.activePrefetches = new WeakMap();
    }

    register(prefetch) {
        // If there are any existing requests, cancel them.
        if (prefetch.element) {
            this.cancel(prefetch.element);
            this.activePrefetches.set(prefetch.element, prefetch);
        }
        prefetch.register();
    }

    cancel(element) {
        const existing = this.activePrefetches.get(element);
        if (existing) {
            existing.cancel();
        }
    }
}

/***/ }),

/***/ "./src/PrefetchScheduler.js":
/*!**********************************!*\
  !*** ./src/PrefetchScheduler.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PrefetchScheduler; });
/* harmony import */ var _queue_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./queue.js */ "./src/queue.js");
/* harmony import */ var _priority__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./priority */ "./src/priority.js");
/* harmony import */ var _delay_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./delay.js */ "./src/delay.js");




const DEFAULT_LIMIT = 2;

// This class maintains the actual download queue of prefetches.
// We use a priority queue, and we also throttle the fetches so that we don't
// download too much at the same time.
class PrefetchScheduler {
    constructor(limit=DEFAULT_LIMIT) {
        this.limit = limit;
        this.queue = new _queue_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
        this.wip = 0;
        this.limit = limit;
        this.prefetchLoopIsRunning = false;
    }

    enqueue(url, priority) {
        if (priority === _priority__WEBPACK_IMPORTED_MODULE_1__["CRITICAL_PRIORITY"]) {
            this.prefetch(url);
            return;
        }

        this.queue.enqueue(url, priority);
        if (!this.prefetchLoopIsRunning) {
            this.run();
        }
    }

    async run() {
        this.prefetchLoopIsRunning = true;

        try {
          while (true) {
            while (this.wip > this.limit) {
              // Trottle this so that we're only downloading a few things at a time.
              await Object(_delay_js__WEBPACK_IMPORTED_MODULE_2__["default"])(100);
            }
  
            const url = this.queue.dequeue();
            if (!url) {
                break;
            }
  
            this.prefetch(url);
          }
        } catch (err) {
          console.error(`Prefetch loop failed`, err);
        } finally {
          this.prefetchLoopIsRunning = false;
        }
    }

    async prefetch(url) {
        try {
            this.wip++;
            await bestAvailablePrefetch(url);
        } catch (err) {
            console.error(`Failed to fetch ${url}`, err);
        } finally {
            this.wip--;
        }
    }

    cancel(url) {
      this.queue.remove(url);
    }
}

//from quicklink implementation https://github.com/GoogleChromeLabs/quicklink/blob/master/src/prefetch.mjs#L53
/**
 *
 * Fetches a given URL using XMLHttpRequest
 * @param {string} url - the URL to fetch
 * @return {Object} a Promise
 */
async function viaXHR(url) {
  //TODO: respect slow network connections by just short circuiting here
  return new Promise((res, rej, req) => {
    req = new XMLHttpRequest();

    req.open(`GET`, url, (req.withCredentials = true));

    req.onload = () => {
      req.status === 200 ? res() : rej();
    };

    req.send();
  });
}

/**
 * Fetches a given URL using `<link rel=prefetch>`
 * @param {string} url - the URL to fetch
 * @return {Object} a Promise
 */
async function viaDOM(url) {
  return new Promise((res, rej, link) => {
    link = document.createElement(`link`);
    link.rel = "prefetch";
    link.href = url;

    link.onload = res;
    link.onerror = err => { 
      console.log(`Prefetch ${url} failed`, err); rej(); 
    };

    document.head.appendChild(link);
  });
}

/**
 * Checks if a feature on `link` is natively supported.
 * Examples of features include `prefetch` and `preload`.
 * @return {Boolean} whether the feature is supported
 */
function hasPrefetch() {
  let link = document.createElement("link");
  return (
    link.relList && link.relList.supports && link.relList.supports("prefetch")
  );
}

function hasFetch() {
  return window && window.fetch;
}

//use viaDOM if rel="prefetch" supported, then use fetch if available, fall back to plain viaXHR
function bestAvailablePrefetch(url) {
  if (hasPrefetch()) {
    return viaDOM(url);
  }

  if (hasFetch()) {
    return fetch(url, { credentials: 'include' });
  }

  return viaXHR(url);
}


/***/ }),

/***/ "./src/delay.js":
/*!**********************!*\
  !*** ./src/delay.js ***!
  \**********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return delay; });
function delay(ms) {
    return new Promise(r => setTimeout(r, ms));
}

/***/ }),

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: init, prefetchOnHover, removePrefetchOnHover, prefetch, preloadOnChange, registerPreloaderInitCallback */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefetchOnHover", function() { return prefetchOnHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removePrefetchOnHover", function() { return removePrefetchOnHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefetch", function() { return prefetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preloadOnChange", function() { return preloadOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerPreloaderInitCallback", function() { return registerPreloaderInitCallback; });
/* harmony import */ var _Fido__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Fido */ "./src/Fido.js");


let fido = undefined;

function init(configuration) {
    if (!fido) {
        fido = new _Fido__WEBPACK_IMPORTED_MODULE_0__["default"](configuration);
        fido.start();
    }
}

function prefetchOnHover(element, priority, ...hrefs) {
    fido.prefetchOnHover(element, priority, ...hrefs);
}

function removePrefetchOnHover(element) {
    fido.onDeleteElement(element);
}

function prefetch(url, priority) {
    fido.prefetch(url, priority);
}

function preloadOnChange(props) {
    if (fido) {
        fido.preloader.onChange(props);
    }
}

function registerPreloaderInitCallback(callback, ...preloadDependencies) {
    if (fido) {
        fido.preloader.registerInitCallback(callback, ...preloadDependencies);
    }
}

/***/ }),

/***/ "./src/preload/Preloader.js":
/*!**********************************!*\
  !*** ./src/preload/Preloader.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Preloader; });
/* harmony import */ var _WorkerRegistry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WorkerRegistry */ "./src/preload/WorkerRegistry.js");


class Preloader {
    constructor() {
        this.workerRegistry = new _WorkerRegistry__WEBPACK_IMPORTED_MODULE_0__["default"]();
        this.initCallbacks = [];
    }

    async register(name, url) {
        try {
            const workerFactory = () => new Worker(url, { name: name });
            const workerRegistration = await this.workerRegistry.register(url, workerFactory);

            // Invoke any init callbacks so that consumers can re-emit any change events
            if (workerRegistration) {
                this.initCallbacks.forEach(callback => {
                    if (workerRegistration.shouldUpdate(callback.props)) {
                        callback.fn((props) => {
                            workerRegistration.worker.postMessage({ 
                                type: 'PRELOAD',
                                props
                            });
                        });
                    }
                });
            }
        } catch (err) {
            console.log(`[Preloader.js] Could not create prefetch web worker from '${url}', ${err}`, err);
        }
    }

    onChange(props) {
        this.workerRegistry.getRegistrations().forEach(registration => {
            if (registration.shouldUpdate(Object.keys(props))) {
                registration.worker.postMessage({
                    type: 'PRELOAD',
                    props
                });
            }
        });
    }

    registerInitCallback(callback, ...preloadDependencies) {
        if (typeof callback === 'function') {
            this.initCallbacks.push({
                fn: callback,
                props: preloadDependencies || []
            });
        }
    }
}

/***/ }),

/***/ "./src/preload/WorkerRegistration.js":
/*!*******************************************!*\
  !*** ./src/preload/WorkerRegistration.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkerRegistration; });
class WorkerRegistration {
    constructor(worker, properties) {
        this.worker = worker;
        this.properties = properties.map(prop => Array.isArray(prop) ? new Set(prop) : new Set([prop]));
    }

    shouldUpdate(properties) {
        // If the set of properties is an empty array, then always perform the update
        if (properties.length === 0) {
            return true;
        }

        // Otherwise, check if the input properties intersect with any of the sets of dependencies of this worker registration
        for (var dependencySet of this.properties) {
            if (properties.some(prop => dependencySet.has(prop))) {
                return true;
            }
        }

        return false;
    }
}

/***/ }),

/***/ "./src/preload/WorkerRegistry.js":
/*!***************************************!*\
  !*** ./src/preload/WorkerRegistry.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkerRegistry; });
/* harmony import */ var _WorkerRegistration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WorkerRegistration */ "./src/preload/WorkerRegistration.js");


// Time (in milliseconds) before we bail on waiting for a web worker to finish initializing
const WORKER_INITIALIZATION_TIMEOUT = 1000;

// The maximum number of distinct web workers allowed to be active at one time
const MAX_WORKERS = 10;

// This class registers preloader web workers.
class WorkerRegistry {
    constructor() {
        this.activeRegistrations = new Map();
    }

    // Returns either a new registration, or undefined in the case where the registration already exists,
    // or failed to initialize
    async register(workerUrl, workerFactory) {
        const url = workerUrl.toString();

        if (this.activeRegistrations.size >= MAX_WORKERS) {
            console.log(`[WorkerRegistry.js] Maximum web worker registration threshold of '${MAX_WORKERS}' reached. Ignoring registration...`);
            return undefined;
        }

        const existingRegistration = this.activeRegistrations.get(url);
        if (!existingRegistration) {
            const worker = workerFactory();

            let timeoutHandle = undefined;
            const initPromise = new Promise((resolve) =>  {
                worker.addEventListener('message', (event) => {
                    if (event.data.type === 'INIT') {
                        const properties = event.data.props;
                        const registration = new _WorkerRegistration__WEBPACK_IMPORTED_MODULE_0__["default"](worker, properties);
                        resolve(registration);
                    }
                });
                worker.postMessage({ type: 'INIT' });
            });
            const timeoutPromise = new Promise((resolve) => {
                timeoutHandle = setTimeout(resolve, WORKER_INITIALIZATION_TIMEOUT);
            });

            const registration = await Promise.race([initPromise, timeoutPromise])
                .then(result => {
                    clearTimeout(timeoutHandle);
                    return result;
                });
            
            // This initialization algorithm is eager and optimistic; we must double-check that no other
            // racing initialization for the same worker has already completed
            if (registration && !this.activeRegistrations.has(url)) {
                this.activeRegistrations.set(url, registration);
                return registration;
            } else {
                worker.terminate();
                return undefined;
            }
        }

        return undefined;
    }

    getRegistrations() {
        return Array.from(this.activeRegistrations.values());
    }
}

/***/ }),

/***/ "./src/priority.js":
/*!*************************!*\
  !*** ./src/priority.js ***!
  \*************************/
/*! exports provided: CRITICAL_PRIORITY, HIGH_PRIORITY, LOW_PRIORITY */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CRITICAL_PRIORITY", function() { return CRITICAL_PRIORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HIGH_PRIORITY", function() { return HIGH_PRIORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOW_PRIORITY", function() { return LOW_PRIORITY; });
const CRITICAL_PRIORITY = 10000;
const HIGH_PRIORITY = 1000;
const LOW_PRIORITY = 1;

/***/ }),

/***/ "./src/queue.js":
/*!**********************!*\
  !*** ./src/queue.js ***!
  \**********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Queue; });
class Queue {
  constructor() {
    this.elements = [];
  }
  enqueue(url, priority) {
    priority = priority || 1;
    const newElement = { url, priority };
    const idx = this.elements.findIndex(el => el.priority < priority);
    if (idx === -1) {
      this.elements.push(newElement);
    } else {
      this.elements.splice(idx, 0, newElement);
    }

    return this.elements.length;
  }

  size() {
    return this.elements.length;
  }
  
  dequeue() {
    if (this.elements.length === 0) {
      return undefined;
    } else {
      return this.elements.splice(0, 1)[0].url;
    }
  }

  remove(url) {
    const idx = this.elements.findIndex(el => el.url === url);
    if (idx >= 0) {
      this.elements.splice(idx, 1);
    }
  }
}

/***/ }),

/***/ "./src/strategies/CompoundTrigger.js":
/*!*******************************************!*\
  !*** ./src/strategies/CompoundTrigger.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CompoundTrigger; });
/* harmony import */ var _PrefetchTrigger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PrefetchTrigger */ "./src/strategies/PrefetchTrigger.js");


// When more than one trigger launch the same prefetch.
class CompoundTrigger extends _PrefetchTrigger__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor(...triggers) {
        super();
        this.triggers = triggers;
    }

    register(onTrigger) {
        for (const trigger of this.triggers) {
            trigger.register(onTrigger);
        }
    }

    cancel() {
        for (const trigger of this.triggers) {
            trigger.cancel();
        }
    }
}

/***/ }),

/***/ "./src/strategies/DelayTrigger.js":
/*!****************************************!*\
  !*** ./src/strategies/DelayTrigger.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DelayTrigger; });
/* harmony import */ var _PrefetchTrigger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PrefetchTrigger */ "./src/strategies/PrefetchTrigger.js");


const DEFAULT_DELAY_MS = 2500;

class DelayTrigger extends _PrefetchTrigger__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor(delayMs=DEFAULT_DELAY_MS) {
        super();
        this.delayMs = delayMs;
    }

    register(onTrigger) {
        this.timeout = setTimeout(onTrigger, this.delayMs)
    }

    cancel() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }        
    }
}

/***/ }),

/***/ "./src/strategies/EagerTrigger.js":
/*!****************************************!*\
  !*** ./src/strategies/EagerTrigger.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EagerTrigger; });
/* harmony import */ var _PrefetchTrigger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PrefetchTrigger */ "./src/strategies/PrefetchTrigger.js");


class EagerTrigger extends _PrefetchTrigger__WEBPACK_IMPORTED_MODULE_0__["default"] {
    register(onTrigger) {
        // An eager prefetch is triggered immediately.
        onTrigger();
    }

    cancel() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }        
    }
}

/***/ }),

/***/ "./src/strategies/HoverTrigger.js":
/*!****************************************!*\
  !*** ./src/strategies/HoverTrigger.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HoverTrigger; });
/* harmony import */ var _PrefetchTrigger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PrefetchTrigger */ "./src/strategies/PrefetchTrigger.js");


const elementsToPrefetches = new WeakMap();

function onHover(event) {
    const element = event.target;
    const prefetch = elementsToPrefetches.get(element);
    if (prefetch) {
        prefetch();
    }
}

class HoverTrigger extends _PrefetchTrigger__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor(element) {
        super();
        this.element = element;
    }

    register(onTrigger) {
        elementsToPrefetches.set(this.element, onTrigger);
        this.element.addEventListener("mouseenter", onHover, { once: true });
    }

    cancel() {
        elementsToPrefetches.delete(this.element);
        this.element.removeEventListener("mouseenter", onHover, { once: true });
    }
}

/***/ }),

/***/ "./src/strategies/IntersectionObserverTrigger.js":
/*!*******************************************************!*\
  !*** ./src/strategies/IntersectionObserverTrigger.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return IntersectionObserverTrigger; });
/* harmony import */ var _PrefetchTrigger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PrefetchTrigger */ "./src/strategies/PrefetchTrigger.js");


const elementsToPrefetches = new WeakMap();

function createIntersectionObserver() {
    if (!window) {
        throw new Error("Cannot create IntersectionObserver in SSR context");
    }

    if ("IntersectionObserver" in window) {
        return new IntersectionObserver(entries => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    const prefetch = elementsToPrefetches.get(entry.target);
                    if (prefetch) {
                        prefetch();
                    }
                }
            }
        });
    } else {
        console.log("IntersectionObserver is not defined for this browser");

        // Stub out a fake IntersectionOverser so that we'll only log an error once.
        return {
            observe() {},
            unobserve() {}
        };
    }
}

let intersectionObserver = undefined;

class IntersectionObserverTrigger extends _PrefetchTrigger__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor(element) {
        super();
        this.element = element;
        if (!intersectionObserver) {
            intersectionObserver = createIntersectionObserver();
        }
    }
    
    register(onTrigger) {
        elementsToPrefetches.set(this.element, onTrigger);
        if (intersectionObserver) {
            intersectionObserver.observe(this.element);
        }
    }

    cancel() {
        elementsToPrefetches.delete(this.element);
        if (intersectionObserver) {
            intersectionObserver.unobserve(this.element);
        }
    }
}

/***/ }),

/***/ "./src/strategies/Prefetch.js":
/*!************************************!*\
  !*** ./src/strategies/Prefetch.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Prefetch; });
// This represents a prefetch; it's URL and priority, and a trigger.
// The trigger listens for some kind of event to cause the URL to be
// prefetched, such as hovering over a link.
class Prefetch {
    constructor(element, urls, priority, scheduler, trigger) {
        this.element = element;
        this.urls = urls;
        this.scheduler = scheduler;
        this.priority = priority;
        this.trigger = trigger;
    }

    register() {
        // This will clear out the existing prefetch if it exists,
        // and register a new one.
        this.cancel();
        this.trigger.register(this.prefetch.bind(this));
    }

    // This is fired by the trigger 
    prefetch() {
        for (const url of this.urls) {
            this.scheduler.enqueue(url, this.priority);
        }

        // And remove the trigger so that it can't fire again.
        this.trigger.cancel();
    }

    // A prefetch can be canceled if, say, the owning element is removed.
    cancel() {
        // If the trigger hasn't fired yet, cancel it.
        this.trigger.cancel();

        for (const url of this.urls) {
            this.scheduler.cancel(url);
        }
    }
}

/***/ }),

/***/ "./src/strategies/PrefetchFactory.js":
/*!*******************************************!*\
  !*** ./src/strategies/PrefetchFactory.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Prefetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Prefetch */ "./src/strategies/Prefetch.js");
/* harmony import */ var _EagerTrigger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EagerTrigger */ "./src/strategies/EagerTrigger.js");
/* harmony import */ var _DelayTrigger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DelayTrigger */ "./src/strategies/DelayTrigger.js");
/* harmony import */ var _IntersectionObserverTrigger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./IntersectionObserverTrigger */ "./src/strategies/IntersectionObserverTrigger.js");
/* harmony import */ var _HoverTrigger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./HoverTrigger */ "./src/strategies/HoverTrigger.js");
/* harmony import */ var _CompoundTrigger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./CompoundTrigger */ "./src/strategies/CompoundTrigger.js");
/* harmony import */ var _priority__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../priority */ "./src/priority.js");









// By default, an eager prefetch is the highest possible priority.
// Everything else defaults to HIGH_PRIORITY;
const DEFAULT_PRIORITIES = {
    EAGER: _priority__WEBPACK_IMPORTED_MODULE_6__["CRITICAL_PRIORITY"]
}

function combineWithDelayIfNeeded(hint, mainTrigger) {
    if (hint.delay) {
        const delayTrigger = new _DelayTrigger__WEBPACK_IMPORTED_MODULE_2__["default"](hint.delay);
        return new _CompoundTrigger__WEBPACK_IMPORTED_MODULE_5__["default"](delayTrigger, mainTrigger);
    } else {
        return mainTrigger;
    }
}

const PrefetchFactory = {
    create(hint, scheduler) {
        let trigger;

        switch (hint.type) {
            case "EAGER":
                trigger = new _EagerTrigger__WEBPACK_IMPORTED_MODULE_1__["default"]();
                break;
            case "IO":
                const ioTrigger = new _IntersectionObserverTrigger__WEBPACK_IMPORTED_MODULE_3__["default"](hint.element);
                trigger = combineWithDelayIfNeeded(hint, ioTrigger);
                break;
            case "HOVER":
                const hoverTrigger = new _HoverTrigger__WEBPACK_IMPORTED_MODULE_4__["default"](hint.element);
                trigger = combineWithDelayIfNeeded(hint, hoverTrigger);
                break;
            case "DELAY":
                trigger = new _DelayTrigger__WEBPACK_IMPORTED_MODULE_2__["default"](hint.delay);
                break;
            default:
                console.error(`Unknown hint type ${hint.type}`);
        }

        const priority = hint.priority 
            || DEFAULT_PRIORITIES[hint.type]
            || _priority__WEBPACK_IMPORTED_MODULE_6__["HIGH_PRIORITY"];

        if (trigger) {
            return new _Prefetch__WEBPACK_IMPORTED_MODULE_0__["default"](hint.element, hint.hrefs, priority, scheduler, trigger);
        }
    }
}

/* harmony default export */ __webpack_exports__["default"] = (PrefetchFactory);

/***/ }),

/***/ "./src/strategies/PrefetchTrigger.js":
/*!*******************************************!*\
  !*** ./src/strategies/PrefetchTrigger.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PrefetchTrigger; });
// This is kind of an abstract class, though probably doesn't need to exist at all
// because this is Javascript.
class PrefetchTrigger {

    // When the prefetch is triggered, it'll call the given function
    register(onTrigger) {
    }

    cancel() {
        // And any clean up happens here.
        // This will either cancel the trigger, or it will clean up any remnants after the trigger has fired.
    }
}

/***/ }),

/***/ "./src/swReg.js":
/*!**********************!*\
  !*** ./src/swReg.js ***!
  \**********************/
/*! exports provided: registerServiceWorker */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerServiceWorker", function() { return registerServiceWorker; });
async function registerServiceWorker() {
    try {
        if ('serviceWorker' in navigator) {
           await navigator.serviceWorker.register('/sw.js', { scope: '/' });
        }
    } catch (err) {
        console.error(`failed to register service worker`, err);
    }
}


/***/ })

/******/ });
});
//# sourceMappingURL=main.js.map